import { useInitialState } from '../contexts/InitialStateContext';

export function useIsInboundVersion() {
  const { userData } = useInitialState();

  return userData.isLoggedIn && userData.profile.isStudioAccount;
}
